import { combineReducers } from 'redux';
import brands from './brandsReducer';
import devices from './devicesReducer';
import models from './modelsReducer';
import selectYourXIndex from './selectYourXIndexReducer';
import selectYourXDropdowns from './selectYourXDropdownsReducer';
import selectedBrandId from './selectedBrandReducer';
import selectedDeviceId from './selectedDeviceReducer';
import ad from './adReducer';
import configPropValues from './configPropsReducer';
import finderTypeId from './finderTypeIdReducer';

const rootReducer = combineReducers({
    // short hand property names
    brands,
    devices,
    models,
    selectYourXIndex,
    selectYourXDropdowns,
    selectedBrandId,
    selectedDeviceId,
    ad,
    configPropValues,
    finderTypeId
});

export default rootReducer;